






















import { editFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
});
